// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__3ojsF","title":"ClientInsurance_title__26LCy","itemText":"ClientInsurance_itemText__rath4"};